export const ThumbnailSection = {
  THUMBNAIL_SECTION_HEAD: '추리, 로맨스, 코미디, 공포\n어디까지 즐겨봤어요?',
  THUMBNAIL_SECTION_BODY:
    '추리를 통한 범인 잡기, 소개팅, 흉가 체험, 파쿠르까지!\n영상으로 노는 새로운 방법, 쥬씨에서 우리 같이 놀아요!',
};
